module.exports = __webpack_public_path__ + "media/images/icons/flags/AO-8470132768db52b9c1fabaeafa175258.svg";